import { Observable } from 'rxjs';
import { CityModel } from '../models/city.model';

export abstract class CityRepository {
    abstract getAllCitys(id: number): Observable<CityModel[]>;
}
